import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AuthComponent,
  tr,
  UnauthorizedComponent,
  NotFoundComponent,
  SessionExpiredComponent,
} from '@kpd/framework-ngx';
import { GotoRedirectComponent } from './shared/components/actions/goto-redirect.component';

// Cannot use arrow functions in routes!
// https://github.com/angular/angular/issues/22700
// https://stackoverflow.com/questions/43113429/angular-cli-error-in-cannot-read-property-loadchildren-of-null/48205304#48205304
export function titleFunction(title: string): () => string {
  return () => tr(title);
}

const routes: Routes = [
  {
    path: '',
    data: {
      routeName: '',
    },
    redirectTo: 'users',
    pathMatch: 'full',
  },
  {
    path: 'goto',
    component: GotoRedirectComponent,
  },
  {
    path: 'auth',
    data: {
      routeName: 'auth',
    },
    component: AuthComponent,
  },
  {
    path: 'expired',
    component: SessionExpiredComponent,
    data: {
      routeName: 'expired',
      breadCrumbData: { titleFunc: titleFunction('logout') },
    },
  },
  {
    path: '404',
    component: NotFoundComponent,
    data: {
      routeName: 'notfound',
      breadCrumbData: { titleFunc: titleFunction('404') },
    },
  },
  {
    path: '403',
    component: UnauthorizedComponent,
    data: {
      routeName: 'unauthorized',
      breadCrumbData: { titleFunc: titleFunction('403') },
    },
  },
  {
    path: '**',
    data: {
      routeName: '**',
    },
    redirectTo: '404',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
